module.exports = __webpack_public_path__ + "static/media/laurel-woods.470e7596.pdf";